import Icon from '../components/Icon.vue'

Icon.register({
  'caret-square-down': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 80v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5h-246c-10.7 0-16.1 12.9-8.5 20.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-square-down.js
// module id = 1156
// module chunks = 0